import { Component, Input, Output } from '@angular/core';
import { AdUtils } from 'src/app/shared/utils/ad.utils';
import { AdSearchService } from 'src/app/shared/services/adsearch.service';
import { GeneralService } from 'src/app/shared/services/general.service';
import { ViewService } from '../../view.service';
import { CurrencyCustomPipe } from 'src/app/core/pipe/pipe-currencyCustom';
import { EventEmitter } from '@angular/core';

@Component({
    selector: 'proposal',
    templateUrl: './proposal.component.html',
    styleUrls: ['./proposal.component.scss']
})
export class ProposalComponent extends AdUtils {

    @Input() info : any;

    @Input() 
    set unitTypeSelected2(val:any){
        this._unitTypeSelected = val;
        if(val?.unit?.id){
            
            let currencyCustom = new CurrencyCustomPipe();
            let amount = currencyCustom.transform(val?.unit?.amount, false);
            this.info.unit_id = val?.unit?.id;
            this.info.unit_title = val?.unit?.title;
            this.info.unit_amount = amount;
        }

        super.ngAfterViewInit();
    };


    @Output() closeCallback = new EventEmitter();
    

    constructor(
        srs : AdSearchService,
        gs : GeneralService,
        vs : ViewService){
            super(srs, gs, vs);

    }

    setConditionSelected(condition) {
        this.conditionSelected = condition;  
    }

    eventCallback(e) { }

    setDefault() {}

    shareUnit(event){

        this.startedShare++;
        return;
        let currencyCustom = new CurrencyCustomPipe();
        let amount = currencyCustom.transform(this.conditionSelected?.amountTotal || this._unitTypeSelected.unit.amount, false);

        this.createShareLink({
            attr:{
                ad_id : this.info.adId,
                unit_id : this._unitTypeSelected.unit.id
            },
            message : '*'+this.info?.title?.trim()+'*\n\n'+
                '*Oferta unidade - '+this.unitTypeSelected.unit.title+'*\n'+
                'Valor: '+amount+'\n\n'+
                'Ficha completa: %link% \n\n'+
                'Fico à disposição para mais informações'
            }
        );
    }

    copyInput(input){
        
    }

    closeModal(event){
        this._unitTypeSelected = null;
        this.closeCallback.emit(event);
    }
}